<template>
    <!-- Footer -->
    <footer class="main-footer">
        <div class="footer-links">
            <div class="container p-l-30 p-r-30">
                <div class="row">
                    <div class="col-lg-9 col-sm-12 col-12">
                        <!-- <h5>Help Centre</h5> -->
                        <ul class="list-unstyled">
                            <!-- <li><a href="#">Contact Us</a></li> -->
                            <!-- <li><a href="#">FAQ</a></li> -->
                            <!-- <li><a href="#">About Us</a></li> -->
                        </ul>
                    </div>
                    <div class="col-lg-3 col-sm-12 col-12 text-lg-right text-sm-center">
                        <div class="d-inline-flex flex-column footer-social">
                            <h5 class="text-lg-left text-sm-center">Follow Us</h5>
                            <ul class="list-unstyled d-flex align-items-center">
                                <li><a href="https://www.facebook.com/share/dqBYNMQrtBaaRv1C/?mibextid=LQQJ4d"><img
                                            src="@/assets/images/social/facebook.svg" alt="facebook" width="24" height="24" loading="lazy"></a></li>
                                <li><a href="https://twitter.com/payangelmoney"><img
                                            src="@/assets/images/social/twitter.svg" alt="twitter" width="24" height="24" loading="lazy"></a></li>
                                <li><a href="https://www.instagram.com/angelcommunities?igsh=MTJjOWJhNGxmbjNpaw=="><img
                                            src="@/assets/images/social/instagram.svg" alt="instagram" width="24" height="24" loading="lazy"></a></li>
                                <li><a href="https://www.linkedin.com/company/payangelmoney"><img
                                            src="@/assets/images/social/linkdin.svg" alt="linkdin" width="24" height="24" loading="lazy"></a></li>
                                <li><a href="https://www.youtube.com/@payangelmoneytransfer/"><img
                                            src="@/assets/images/social/yt.svg" alt="yt" width="24" height="24" loading="lazy"></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-text">
            <div class="container p-l-30 p-r-30">
                <div class="row">
                    <div class="col-12">
                        <p>ANGELCOMMUNITIES®, PAYANGEL®, PAYINC®, BUZZMONEY®, and MONEYTUBE® are trading names of PAYINC
                            GROUP LIMITED, Registered in England and Wales; Registration Number: 8126178. PAYINC®
                            is authorised by the Financial Conduct Authority (FCA) for the provision of payment services
                            (FRN: <a href="http://register.fca.org.uk/ShPo_FirmDetailsPage?id=001b000000NMluEAAT"
                                class="text-primary" target="_blank">608108</a>).
                            Money Laundering Regulation Number (MSB): 12690216; Issued by HM Revenue &
                            Customs (HMRC). <a href="https://www.payangel.com/money-laundering-statement"
                                class="text-primary" target="_blank">Money Laundering
                                Statement</a>. Registered Address: Regus House, Victory Way,
                            Admirals Park, Dartford, Kent, DA2 6QD, United Kingdom.</p>
                        <p>PAYINC is registered in Canada as PAYINC (CA) LIMITED and registered with the Financial
                            Transactions and Report Analysis Centre of Canada (FINTRAC) as a Money Service Business (MSB
                            registration number: M14298760).</p>
                        <p>PAYINC is registered in the United States as PAYINC US CORP, a Delaware C-Corp, and
                            registered with the United States Financial Crimes Enforcement Network (FinCEN) as a Money
                            Service Business (MSB registration number: 31000231722161)</p>
                        <p>PAYINC® provides international money transfer and payment services from the UK, Canada,
                            and Europe to sub-Saharan Africa.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bottom">
            <div class="container p-l-30 p-r-30">
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <p class="copy">Copyright © 2013 - {{ currentYear }} PAYINC GROUP LIMITED. <br> All Right Reserved.</p>
                    </div>
                    <div class="col-lg-6 col-12">
                        <ul class="list-unstyled d-flex align-items-center justify-content-center justify-content-lg-end">
                            <li><a href="/faqs">FAQs</a></li>
                            <li><a href="/terms-and-conditions">Terms and Conditions</a></li>
                            <li><a href="/cookie-policy">Cookies policy</a></li>
                            <li><a href="/privacy-policy">Privacy Policy</a></li>
                            <li><a href="/acceptable-use-policy">Acceptable Use Policy</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
    name: "Footer",
    data() {
        return {
        currentYear: new Date().getFullYear()
        };
    }
};
</script>
